import Joi from 'joi';

export const validationFormContact = Joi.object({
  nome: Joi.string().required().min(3).messages({
    'string.empty': 'O campo NOME é obrigatório!',
    'string.base': 'O campo NOME deve conter apenas texto!',
    'string.min': 'Digite um NOME válido!',
  }),
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      'string.empty': 'O campo E-MAIL é obrigatório!',
      'string.base': 'O campo E-MAIL deve ser do tipo texto!',
      'string.email': 'Digite um E-MAIL válido!',
    }),
  telefone: Joi.string().min(10).required().messages({
    'string.pattern.base': 'Digite um número de TELEFONE válido!',
    'string.empty': 'O campo TELEFONE é obrigatório!',
    'string.min': 'Digite um número de TELEFONE válido!',
  }),

  momento: Joi.string().required().messages({
    'string.empty': 'Por favor, indique o seu momento atual!',
  }),
  empreendimento: Joi.string().required().messages({
    'string.empty': 'Campo EMPREENDIMENTO obrigatório!',
  }),
  horario: Joi.string().required().messages({
    'string.empty': 'Campo HORÁRIO obrigatário!',
  }),
  canal: Joi.string().required().messages({
    'string.empty': 'Campo CANAL obrigatário!',
  }),
  criadoEm: Joi.date().required().messages({
    'string.empty': 'Campo DATA obrigatório!',
  }),
});
